import React, { useState } from 'react';
import ReportsOverview from './ReportsOverview';
import ReportsActiveUsers from './ReportsActiveUsers';
import ReportsFeatureAdoption from './ReportsFeatureAdoption';
import ReportsConversionFunnel from './ReportsConversionFunnel';
import ReportsRetention from './ReportsRetention';
import ReportsUserJourney from './ReportsUserJourney';
import ReportsUserIntelligence from './ReportsUserIntelligence';

const TABS = [
  { key: 'overview', label: 'Overview' },
  { key: 'active', label: 'Active Users' },
  { key: 'features', label: 'Feature Usage' },
  { key: 'conversion', label: 'Conversion' },
  { key: 'retention', label: 'Retention' },
  { key: 'journey', label: 'User Journey' },
  { key: 'intelligence', label: 'User Intelligence' },
];

function Reports() {
  const [activeSection, setActiveSection] = useState('overview');
  const [journeyUsername, setJourneyUsername] = useState('');

  const handleNavigateToJourney = (username) => {
    setJourneyUsername(username);
    setActiveSection('journey');
  };

  return (
    <div className="reports-management">
      <div className="roles-intro">
        <h2>Analytics Dashboard</h2>
        <p>
          Track user activity, feature adoption, conversion funnels, and retention across the platform.
        </p>
      </div>

      <div className="roles-section-tabs analytics-tabs">
        {TABS.map((tab) => (
          <button
            key={tab.key}
            className={`section-tab ${activeSection === tab.key ? 'active' : ''}`}
            onClick={() => setActiveSection(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className="roles-content">
        {activeSection === 'overview' && <ReportsOverview />}
        {activeSection === 'active' && <ReportsActiveUsers />}
        {activeSection === 'features' && <ReportsFeatureAdoption />}
        {activeSection === 'conversion' && <ReportsConversionFunnel />}
        {activeSection === 'retention' && <ReportsRetention />}
        {activeSection === 'journey' && <ReportsUserJourney initialUsername={journeyUsername} />}
        {activeSection === 'intelligence' && (
          <ReportsUserIntelligence onNavigateToJourney={handleNavigateToJourney} />
        )}
      </div>
    </div>
  );
}

export default Reports;
